import qs from 'query-string';

/**
 * Custom parameter/query string serializer with support for complex types that get serialized as JSON.
 * @param params The query parameters.
 * @returns The serialized query string.
 */
export function paramsSerializer(params: Record<string, any>): string {
  const preParsed: Record<string, any> = {};

  for (const [key, value] of Object.entries(params)) {
    switch (typeof value) {
      // ignore functions
      case 'function':
        break;
      // serialize complex objects as JSON
      case 'object':
        if (Array.isArray(value)) {
          preParsed[key] = value.map((item) => (typeof item === 'object' ? JSON.stringify(item) : item));
        } else {
          preParsed[key] = JSON.stringify(value);
        }
        break;
      default:
        preParsed[key] = value;
        break;
    }
  }

  return qs.stringify(preParsed);
}
